/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { paginateParticipants, QueryInfo } from './participantsPaginate'
import {
  formParticipantsSummaryByFormEventId,
  participantsShirtSummaryByEventId,
  participantsSummaryByEventId,
} from '../api/queries'

export const listParticipantsSummaryByEvent = async ({
  eventId = '',
  isFree = false,
  isFormParticipant = false,
  startTimestamp = '',
}) => {
  const queryInfo: QueryInfo = {
    queryName: isFormParticipant
      ? 'formParticipantsByFormEventId'
      : 'participantsByEventId',
    query: isFormParticipant
      ? formParticipantsSummaryByFormEventId
      : participantsSummaryByEventId,
    variables: isFormParticipant
      ? { formEventId: eventId }
      : { eventId, ...(!isFree && { filter: { orderId: { attributeExists: true } } }) },
    isFormParticipant,
  }

  return paginateParticipants({ queryInfo, isFree, startTimestamp })
}

export const listParticipantsShirtSummaryByEvent = async ({
  eventId = '',
  isFree = false,
  isFormParticipant = false,
  startTimestamp = '',
}) => {
  const queryInfo: QueryInfo = {
    queryName: isFormParticipant
      ? 'formParticipantsByFormEventId'
      : 'participantsByEventId',
    query: isFormParticipant
      ? formParticipantsSummaryByFormEventId
      : participantsShirtSummaryByEventId,
    variables: isFormParticipant
      ? { formEventId: eventId }
      : { eventId, ...(!isFree && { filter: { orderId: { attributeExists: true } } }) },
    isFormParticipant,
  }

  return paginateParticipants({ queryInfo, isFree, startTimestamp })
}
